import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Sort.css';

class Sort extends React.Component {
  render() {
    return (
      <div className={cx(s.Sort, s[this.props.className])}>
        {this.props.children}
      </div>
    );
  }
}

Sort.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default withStyles(s)(Sort);



// WEBPACK FOOTER //
// ./src/components/Sort/Sort.js